import Activate from "./Activate.jsx";
export default Activate;